module.exports = __webpack_public_path__ + "img/coffee-beans-big.e2af2d27.png";